import { ReactNode } from 'react';

import { Button, Dialog } from '@raystack/apsara';
import { For, Show } from '@studio/hoc';

interface DialogModalProps {
  heading: string | ReactNode;
  subHeading: string | ReactNode;
  actionButtons: Array<ReactNode>;
  onClose: VoidFunction;
  children?: ReactNode;
  showCancelBtn?: boolean;
}

export const DialogModal = ({
  onClose,
  heading,
  subHeading,
  actionButtons = [],
  children,
  showCancelBtn = true
}: DialogModalProps) => {
  return (
    <Dialog open onOpenChange={onClose}>
      <Dialog.Content width='400px' overlayBlur>
        <Dialog.Body>
          <Dialog.Title>{heading}</Dialog.Title>
          <Dialog.Description>{subHeading}</Dialog.Description>
          {children}
        </Dialog.Body>
        <Dialog.Footer>
          <Show when={showCancelBtn}>
            <Dialog.Close asChild>
              <Button color='neutral' variant='outline'>
                Cancel
              </Button>
            </Dialog.Close>
          </Show>
          <For each={actionButtons}>{button => <>{button}</>}</For>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};
